import React from 'react';
import edUserImage from  '../../../assets/img/event-details-imgs/ed-userimg.png';
import interestedIcon from '../../../assets/img/event-details-imgs/icon/interested-icon.svg'
import goingIcon from '../../../assets/img/event-details-imgs/icon/going-icon.svg'
const EventShortCart = () => {
    return (
        <div className="row mb-4">
            <div className="col-12">
                <div className="w-100 px-4 py-4 short-cart-design ">
                    <div className="row mb-4">
                        <div className="col gap-2 d-flex justify-content-start align-items-center">
                            <span className="ed_by">Event by :</span>
                            <img className="rounded-circle" src={edUserImage} alt='' />
                            <span className="txt_wa">Lily Luis</span>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col gap-2 d-flex justify-content-start align-items-center">
                            <span className="ed_by">Response :</span>
                            <span className="txt_wa">25 people responded</span>
                        </div>
                    </div>
                    <div className="row mb-5">
                        <div className="col gap-2 d-flex justify-content-start align-items-center">
                            <span className="ed_by">Privacy :</span>
                            <span className="txt_wa">Public, Anyone can join</span>
                        </div>
                    </div>
                    <div className="row gap-2 gap-xl-0">
                        <div className="col-12 col-xl-6 gap-2 d-flex justify-content-start align-items-center">
                            <img src={interestedIcon} alt='' />
                                <span className='event-short-cart-sum'>68</span>
                                <span className="db_para">Interested</span>
                        </div>
                        <div className="col-12 col-xl-6 gap-2 d-flex justify-content-start align-items-center">
                            <img src={goingIcon} alt='' />
                            <span className='event-short-cart-sum'>18</span>
                            <span className="db_para">Going</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventShortCart;